import { Typography } from "@mui/material";

export const CopyWaiting = () => {
  return <Typography color="secondary">Waiting to be copied...</Typography>;
};
